module.exports = __webpack_public_path__ + "img/SER-B-1-II.4d01f6c7.png";